import styled from "styled-components";

export const Website = styled.a`
  font-size: clamp(1rem, 1.5vw, 1.5rem);
`;

export const Picture = styled.img`
  border: #e5398d 1vw solid;
  width:80%;
  border-radius: 50%;
`;

export const Name = styled.h1`
  font-size: clamp(1.25rem, 2vw, 2rem);
`;

export const Sektion = styled.h2`
  font-size: clamp(1rem, 1.5vw, 1.5rem);
  color: brown;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
